var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-box"},[_c('img',{attrs:{"src":require("../../../../static/images/img_page_not_found.png"),"alt":""}}),_c('div',[_c('span',[_vm._v("404...您访问的页面不见了！")]),_c('el-button',{attrs:{"icon":"el-icon-s-home"},on:{"click":_vm.toHome}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }